<style scoped>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
    color: #768192;
    border-color: none; 
    border : none;
    background-color: #486ba7;
}
.button:disabled {
  cursor: no-drop;
}
</style>

<template>
  <div class="card">
    <header class="card-header bg-primary text-white d-flex align-items-center font-weight-bold"> Data Peserta Sertifikasi 
    </header>
     <div class="card-body">
      <div class="row">
        <div class="col-sm-12 col-xl-12">
            <div class="form-group">
              <label for="" class="font-weight-bold">Pilih Level</label>
              <multiselect
                class="mulit-select"
                label="namaLevel"
                placeholder="Pilih Level"
                v-model="levelSelect"
                :show-labels="false"
                id="selectLevel"
                :options="optionMasterLevel"
              ></multiselect>
            </div>
          </div>
      </div>
        <div class="row">
            <div class="col-sm-12 col-xl-6">
                <label for="" class="font-weight-bold">Pilih Periode</label>
                <multiselect
                  class="multi-select"
                  label="label"
                  placeholder="Pilih Periode"
                  :show-labels="false"
                  v-model="periodeSelect"
                  :options="dataTahun"
                ></multiselect>
            </div>
            <div class="col-sm-12 col-xl-6">
                <label for="exampleFormControlSelect1">Nama Peserta</label>
                <input type="text" v-model="searchData.namaPeserta" class="form-control" placeholder="Nama Peserta">
            </div>
        </div>
        <br>
      </div>
    <div class="card-body">
    <ul class="nav nav-tabs bg-active border-0 border-bottom-0" id="myTab" role="tablist">            
          <li class="nav-item" ref="tablunas">
            <div
              class="nav-link p-3 px-4 font-weight-bold text-white active "
              id="home-tab"
              data-toggle="tab"
              href="#home"
              style="cursor: pointer"
              role="tab"
              @click="tabChange('approved')"
              aria-controls="home">
                Lunas
                <span class="badge badge-success text-white">0</span>
              </div>
          </li>
          <li class="nav-item">
            <div
              class="nav-link p-3 px-4 font-weight-bold text-white "
              id="belum-lunas"
              data-toggle="tab"
              href="#belum-lunas"
              style="cursor: pointer"
              role="tab"
              @click="tabChange('belum_lunas')"
              aria-controls="belum-lunas" >
                Belum Lunas
                <span class="badge badge-warning text-white">0</span>
              </div>
          </li>
          <li class="nav-item">
            <div
              class="nav-link p-3 px-4 font-weight-bold text-white "
              id="profile"
              data-toggle="tab"
              href="#profile"
              style="cursor: pointer"
              role="tab"
              @click="tabChange('verify')"
              aria-controls="profile" >
                Verify
                <span class="badge badge-info text-white">0</span>
              </div>
          </li>
          
        </ul>
        <CDataTable :items="items" :fields="fields" hover sorter>
            <template #no="{ index }">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #nama="{ item }">              
              <td class="py-2">{{ item.nama ? item.nama : "-" }}</td>
            </template>
            <template #email="{ item }">              
              <td class="py-2">{{ item.email ? item.email : "-" }}</td>
            </template>
            <template #aksi="{item}">
                <router-link :to="'/sertifikasi-new/data-peserta-sertifikasi-detail/' +item.idSertifikasiPeserta">
                    <CButton
                        v-c-tooltip="'Lihat Mata Uji Peserta'"
                        color="success"
                        class="btn-sm mr-2"
                        square>
                        <i class="fa fa-eye" aria-hidden="true"></i>
                    </CButton> 
                </router-link>
                <router-link
                  v-if="searchData.statusPembayaran == 'verify'"
                  :to="'/sertifikasi-new/data-peserta/data-dokumen/' + item.idSertifikasiPeserta">
                  <CButton
                    v-c-tooltip="'Lihat Dokumen Peserta'"
                    color="warning"
                    class="btn-sm text-white" square>
                    <i class="fa fa-file" aria-hidden="true"></i>
                  </CButton>
                </router-link>
            </template>
        </CDataTable>
    </div>
</div>
</template>
<script>
import DataPesertaService from "@/services/sertifikasi/data-peserta.service.new.js";
import { AlertUtils } from "@/mixins/AlertUtils";
import FilterSertifikasi from "@/components/sertifikasi/datapeserta/FilterSertifikasi";
import PeriodeService from "@/services/datamaster/periode.service";
import LevelService from "@/services/datamaster/level.service";

const fields = [
  { key: "no", label: "No." },
  { key: "nama", label: "Nama Peserta"},
  { key: "email", label: "Email"},
  { key: "aksi", label: 'aksi'}
];

export default {
    mixins: {
        AlertUtils
    },
    components: {
        FilterSertifikasi
    },
    data() {
        return {
            fields,
            indexed: 0,
            items: [],
            levelSelect: [],
            dataTahun: [],
            periodeSelect: {},
            optionMasterLevel: [],
            tab_selected: {
                aria_selected_approved: true,
                aria_selected_verify: false,
                aria_selected_belum_lunas: false
            },
            searchData: {
              currentPage:0,
              pageSize:10,
              statusPembayaran:'approved',
              periode: {}, 
              namaPeserta: "",
              level:""
            }
        }
    }, 
    watch: {
      'levelSelect' : function(value) {
        this.searchData.level = value.idLevelAnggota;
        this.getData(this.searchData.currentPage,
            this.searchData.pageSize,
            this.searchData.statusPembayaran,
            this.searchData.periode,
            this.searchData.namaPeserta,
            this.searchData.level);
        },
      'periodeSelect' : function(value) {
        this.searchData.periode = value.value
        this.getData(this.searchData.currentPage,
            this.searchData.pageSize,
            this.searchData.statusPembayaran,
            this.searchData.periode,
            this.searchData.namaPeserta,
            this.searchData.level);
      }, 
      'searchData.namaPeserta' : function(value) {
        clearTimeout(this.timeOutFilterNamaPeserta);
        var vm = this;
        this.timeOutFilterNamaPeserta = setTimeout(function(){
          vm.searchData.namaPeserta = value;
          vm.getData(vm.searchData.currentPage,
                    vm.searchData.pageSize,
                    vm.searchData.statusPembayaran,
                    vm.searchData.periode,
                    vm.searchData.namaPeserta,
                    vm.searchData.level);
        },1000);
      }
    },
    mounted() {
      this.getPeriode()
      this.getAllLevel()
      console.log(this.searchData);
      this.getData(this.searchData.currentPage,
            this.searchData.pageSize,
            this.searchData.statusPembayaran,
            this.searchData.periode,
            this.searchData.namaPeserta,
            this.searchData.level);
    },
    methods: {
        getData(
            currentPage,
            pageSize,
            statusPembayaran,
            periode,
            namaPeserta, 
            level
            ) {
            let loader = this.$loading.show({
                container: false ? null : this.$refs.formContainer,
                canCancel: true,
                onCancel: this.onCancel,
            });

            var vm = this;

            console.log(this.searchData);
            DataPesertaService.getDataPesertaSertifikasi(
                currentPage,
                pageSize,
                statusPembayaran,
                periode,
                namaPeserta,
                level
            )
                .then((response) => {
                console.log(response)
                loader.hide();          
                vm.items = response.data.content;
                // vm.pagination.totalPages = response.data.totalPages;
                // vm.currentPageDataPesertaSertifikasi =
                //     response.data.pageable.pageNumber + 1;
                })
                .catch((error) => {
                    console.log(error);
            });
        },
        tabChange(value) {
          console.log('tab is change')
            switch (value) {
                case "approved":
                this.tab_selected.aria_selected_approved = true;
                this.tab_selected.aria_selected_verify = false;
                this.tab_selected.aria_selected_belum_lunas = false;
                this.searchData.statusPembayaran = "approved";
                // this.getData(
                //     0,
                //     10,
                //     this.searchData.id_sertifikasi,
                //     "approved",
                //     this.searchData.periode
                // );
                this.getData(this.searchData.currentPage,
                    this.searchData.pageSize,
                    this.searchData.statusPembayaran,
                    this.searchData.periode,
                    this.searchData.namaPeserta,
                    this.searchData.level);
                break;
                case "verify":
                this.tab_selected.aria_selected_approved = false;
                this.tab_selected.aria_selected_verify = true;
                this.tab_selected.aria_selected_belum_lunas = false;
                this.searchData.statusPembayaran = "verify";
                // this.getCountLunas();
                // this.getCountBelumLunas();
                // this.getCountLainnya();

                // this.getData(
                //     0,
                //     10,
                //     this.searchData.id_sertifikasi,
                //     "needs_verify",
                //     this.searchData.periode
                // );
                this.getData(this.searchData.currentPage,
                    this.searchData.pageSize,
                    this.searchData.statusPembayaran,
                    this.searchData.periode,
                    this.searchData.namaPeserta,
                    this.searchData.level);
        
                break;
                case "belum_lunas":
                this.tab_selected.aria_selected_approved = false;
                this.tab_selected.aria_selected_verify = false;
                this.tab_selected.aria_selected_belum_lunas = true;
                this.searchData.statusPembayaran = "belum_lunas";
                // this.getCountLunas();
                // this.getCountBelumLunas();
                // this.getCountLainnya();

                // this.getData(
                //     0,
                //     10,
                //     this.searchData.id_sertifikasi,
                //     "belum_lunas",
                //     this.searchData.periode
                // );
                this.getData(this.searchData.currentPage,
                    this.searchData.pageSize,
                    this.searchData.statusPembayaran,
                    this.searchData.periode,
                    this.searchData.namaPeserta,
                    this.searchData.level);
        
                break;
                default:
                break;
            }
          },
        getPeriode() {
        PeriodeService.getPeriodeSelect()
          .then((response) => {
            this.dataTahun = response.data.data;
            this.periodeSelect = this.dataTahun.find((el) => el.status === "1");
            this.searchData.periode = this.periodeSelect.value;
          })
          .catch((error) => {
          });
      },
      getAllLevel() {
        this.loading = true;
        LevelService.getLevel(0,1000000,'default')
          .then(response => {
              this.optionMasterLevel = response.data.data.content
              
              if(this.tipe_halaman == "all_data") {
                var data = {
                  idLevelAnggota: "default",
                  namaLevel: "Semua Data"
                }
                
                this.optionMasterLevel.unshift(data);
              }
              
              this.loadingMultiSelect.isLoadingLevel = false
              this.items_master_level = response.data.data.content;
              this.level = this.items_master_level[0]
              this.loading = false;
          }).catch(error => {
              // comment console console.log(error)
          })
      }
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
